import { type FilterSelectOptionProps } from '../components/inputs/filter-select-dropdown/filter-select-dropdown.component';
import { type DurationOwnedButton } from '../components/product-components/product-reviews/write-review-modal/duration-owned-buttons/duration-owned-buttons.component';
import { type WriteReviewFormInputs } from '../helpers/product-helper/reviews/reviews.helper';

export const INITIAL_WRITE_REVIEW_FORM_STATE: WriteReviewFormInputs = {
	rating: 0,
	title: '',
	reviewText: '',
	photoUrls: [],
	videoUrl: '',
	isRecommended: null,
	howLongHaveYouHadTheProduct: null,
	isIncentivizedReview: null,
	badgeCollection: null,
	userDisplayName: '',
	userEmail: '',
	agreedToTermsAndConditions: false
};

// for use with StarsRatingInput component
export const RATING_IN_WORDS_DICT = {
	0: '',
	1: 'Poor',
	2: 'Fair',
	3: 'Average',
	4: 'Good',
	5: 'Excellent'
};

// for use with the badge collection dropdown option
export const BADGE_COLLECTION_DROPDOWN_OPTIONS: FilterSelectOptionProps[] = [
	{ name: 'Contractor', value: 'CONTRACTOR' },
	{ name: 'DIY Builder', value: 'DIY_BUILDER' },
	{ name: 'Homeowner', value: 'HOMEOWNER' },
	{ name: 'Blogger', value: 'BLOGGER' },
	{ name: 'Employee', value: 'EMPLOYEE' },
	{ name: 'Other', value: 'OTHER' }
];
// for use with duration owned buttons
export const DURATION_OWNED_OPTIONS: DurationOwnedButton[] = [
	{ label: 'Less than 6 months', value: 'LESS_THAN_6_MONTHS' },
	{ label: '6 months to 1 year', value: 'SIX_MONTHS_TO_1_YEAR' },
	{ label: 'Over 1 year', value: 'OVER_1_YEAR' }
];

// for use with CommonContainerWrapper component
export const SELECTION_TITLE_COMMON_CLASSES = 'f4 mb1';
export const SELECTION_GROUP_COMMON_CLASSES = 'tl mb4';

export const WRITE_REVIEW_INPUT_MAX_LENGTH = 250;
export const WRITE_REVIEW_TEXTAREA_MAX_LENGTH = 2000;
export const WRITE_REVIEW_INPUT_MIN_LENGTH = 50;

export const ERROR_TEXT_CLASSES = 'theme-error f7 ml2 pt1';

export enum ReviewsVariationInteractionsEnum {
	WRITE_A_REVIEW = 'write-a-review',
	LOAD_MORE = 'load-more',
	OPEN_INDIVIDUAL_MODAL = 'open-individual-modal',
	RATING_FILTER = 'rating-filter',
	SORT_REVIEWS = 'sort-reviews',
	HELPFUL = 'helpful',
	SEARCH_REVIEWS = 'search-reviews',
	OPEN_REVIEWS_IMAGE_GALLERY = 'open-reviews-image-gallery'
}
